import { z } from 'zod';
export const ExportFormatDataSchema = z.enum(['csv', 'xlsx', 'json', 'parquet']);
export const ExportFormatInvoicesSchema = z.enum(['csv', 'xlsx', 'json', 'pdf']);
export const ExportFormatEventsSchema = z.enum([
    'csv',
    'xlsx',
    'json',
    'parquet',
    'jsonl',
]);
export const ExportCompressionSchema = z.enum(['none', 'gzip', 'zip']);
export const ExportStatusSchema = z.enum([
    'queued',
    'processing',
    'completed',
    'failed',
    'expired',
]);
export const ExportTypeSchema = z.enum([
    'usage',
    'invoices',
    'analytics',
    'events',
]);
export const EXPORT_STATUS = ExportStatusSchema.enum;
export const EXPORT_TYPE = ExportTypeSchema.enum;
export const ExportUsageSchema = z.object({
    format: ExportFormatDataSchema.default('csv'),
    date_range: z.object({
        start: z.string(),
        end: z.string(),
    }),
    filters: z
        .object({
        agent_ids: z.array(z.string()).optional(),
        customer_external_ids: z.array(z.string()).optional(),
        event_names: z.array(z.string()).optional(),
        signal_ids: z.array(z.string()).optional(),
    })
        .optional(),
    fields: z.array(z.string()).optional(),
    aggregation: z
        .object({
        group_by: z.array(z.string()),
        metrics: z.array(z.object({
            field: z.string(),
            operation: z.enum(['sum', 'count', 'avg']),
        })),
    })
        .optional(),
    compression: ExportCompressionSchema.default('gzip').optional(),
    email_when_ready: z.boolean().default(false).optional(),
});
export const ExportInvoicesSchema = z.object({
    format: ExportFormatInvoicesSchema.default('csv'),
    date_range: z.object({
        start: z.string(),
        end: z.string(),
    }),
    filters: z
        .object({
        customer_ids: z.array(z.string()).optional(),
        statuses: z
            .array(z.enum(['draft', 'open', 'paid', 'void', 'uncollectible']))
            .optional(),
        min_amount: z.number().optional(),
        max_amount: z.number().optional(),
    })
        .optional(),
    include_line_items: z.boolean().default(false).optional(),
    compression: ExportCompressionSchema.default('gzip').optional(),
    email_when_ready: z.boolean().default(false).optional(),
});
export const ExportAnalyticsSchema = z.object({
    format: ExportFormatDataSchema.default('csv'),
    date_range: z.object({
        start: z.string(),
        end: z.string(),
    }),
    analytics_type: z.enum(['customer', 'revenue', 'usage', 'roi', 'costs']),
    granularity: z.enum(['day', 'week', 'month']).default('day').optional(),
    filters: z.record(z.string(), z.unknown()).optional(),
    compression: ExportCompressionSchema.default('gzip').optional(),
    email_when_ready: z.boolean().default(false).optional(),
});
export const ExportEventsSchema = z.object({
    format: ExportFormatEventsSchema.default('csv'),
    date_range: z.object({
        start: z.string(),
        end: z.string(),
    }),
    filters: z
        .object({
        event_names: z.array(z.string()).optional(),
        customer_external_ids: z.array(z.string()).optional(),
        agent_ids: z.array(z.string()).optional(),
        signal_ids: z.array(z.string()).optional(),
        processed_status: z
            .enum(['processed', 'unprocessed', 'error'])
            .optional(),
    })
        .optional(),
    include_raw_data: z.boolean().default(false).optional(),
    compression: ExportCompressionSchema.default('gzip').optional(),
    email_when_ready: z.boolean().default(false).optional(),
});
export const ExportResponseSchema = z.object({
    id: z.string(),
    type: z.string(),
    format: z.string(),
    status: ExportStatusSchema,
    progress_percentage: z.number().min(0).max(100),
    estimated_completion: z.string().nullable(),
    file_size_bytes: z.number().nullable(),
    download_url: z.string().nullable(),
    expires_at: z.string().nullable(),
    error_message: z.string().nullable(),
    created_at: z.string(),
    completed_at: z.string().nullable(),
});
export const ExportListQuerySchema = z.object({
    page: z.coerce.number().min(1).default(1).optional(),
    limit: z.coerce.number().min(1).max(100).default(20).optional(),
    status: ExportStatusSchema.optional(),
    type: ExportTypeSchema.optional(),
    format: z.string().optional(),
    start_date: z.string().optional(),
    end_date: z.string().optional(),
});
export const PaginatedExportsResponseSchema = z.object({
    data: z.array(ExportResponseSchema),
    pagination: z.object({
        page: z.number(),
        limit: z.number(),
        total: z.number(),
        total_pages: z.number(),
    }),
});
export const ExportParamsSchema = z.object({
    id: z.string(),
});
export const ExportStatsSchema = z.object({
    total_exports: z.number(),
    exports_by_status: z.object({
        queued: z.number(),
        processing: z.number(),
        completed: z.number(),
        failed: z.number(),
        expired: z.number(),
    }),
    exports_by_type: z.object({
        usage: z.number(),
        invoices: z.number(),
        analytics: z.number(),
        events: z.number(),
    }),
    total_file_size_bytes: z.number(),
    average_processing_time_ms: z.number(),
    success_rate: z.number(),
});
//# sourceMappingURL=index.js.map